import './btn_basic.less';

import noop from 'lodash/noop';
import React from 'react';
import classNames from 'classnames';

import Tipsy from 'zoomforth_component_lib/tipsy.jsx';


const Buttonizer = ({ 
    Tag, 
    primary, primaryDeemphasized, dark, secondary, alternative, danger, dangerDeemphasized, primaryBorderless, dangerBorderless, link,
    leftmost, middle, rightmost,
    fullwidth, 
    small,
    active, 
    tellRef, 
    className, 
    type, 
    tooltip, 
    tooltipPosition, 
    tooltipClassName, 
    disabled, 
    disabledReason,
    onClick, 
    onDisabledClick, 
    onEveryClick, 
    children, 
    ...rest 
  })=> {

  const renderedTooltip = tooltip ? tooltip : disabledReason;

  if (!type) {
    if (primary) {
      type = 'primary';
    } else if (primaryDeemphasized) {
      type = 'primary-deemphasized';
    } else if (secondary) {
      type = 'secondary';
    } else if (dark) {
      type = 'dark';
    } else if (alternative) {
      type = 'alternative';
    } else if (danger) {
      type = 'danger';
    } else if (dangerDeemphasized) {
      type = 'danger-deemphasized';
    } else if (primaryBorderless) {
      type = 'primary-borderless';
    } else if (dangerBorderless) {
      type = 'danger-borderless';
    } else if (link){
      type = 'link';
    } else {
      type = 'primary';
    }
  }

  const btn = (
    <Tag 
      {...rest}
      ref={tellRef}
      // Disabled buttons shouldn't be tabbable
      tabIndex={disabled ? '-1' : null}
      // Ignore `click`s if this button is `disabled`
      onClick={(e)=> { onEveryClick(e); (disabled ? onDisabledClick : onClick)(e); }}
      // ignore focus events if disabled
      onFocus={disabled ? (e)=> { e.target.blur(); } : null}
      className={classNames(
        'btn-basic',  
        {
          'btn-set-leftmost': leftmost,
          'btn-set-rightmost': rightmost,
          'btn-set-middle': middle,
          'active': active,
          'btn-basic-primary': type === 'primary',
          'btn-basic-primary-deemphasized': type === 'primary-deemphasized',
          'btn-basic-dark': type === 'dark',
          'btn-basic-alternative': type === 'alternative',
          'btn-basic-secondary': type === 'secondary',
          'btn-basic-danger': type === 'danger',
          'btn-basic-danger-deemphasized': type === 'danger-deemphasized',
          'btn-basic-primary-borderless': type === 'primary-borderless',
          'btn-basic-danger-borderless': type === 'danger-borderless',
          'btn-basic-link': type === 'link',
          disabled: disabled,
          fullwidth: fullwidth,
          small: small
        },
        className

      )}>

      {children}


    </Tag>
  );


  if (renderedTooltip)  {

    return (
      <Tipsy className={tooltipClassName} content={renderedTooltip} placement={tooltipPosition || 'bottom'}>
        { btn }
      </Tipsy>
    );

  } else {
    return btn;
  }
};


Buttonizer.defaultProps = {
  onEveryClick: noop,
  onDisabledClick: noop,
  onClick: noop
};

const Button = (props)=>
  <Buttonizer role="button" Tag="button" {...props} />;

export { Buttonizer };

export default Button;
